import React from 'react';
import { PieChart as RePieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { kebabCase } from 'lodash';
import classNames from 'classnames';

interface Props {
  data: Array<{ name: string; color?: string }>;
  className?: string;
  sortedClockwise?: boolean;
}

export function PieChart({ data, className, sortedClockwise }: Props): JSX.Element {
  const colors = data.map((item) => {
    return `var(--color-ticket-${kebabCase(item.name)})`;
  });

  return (
    <div className={classNames('pie-chart', className)}>
      <ResponsiveContainer>
        <RePieChart margin={{ top: 0 }}>
          <Pie
            data={data}
            dataKey="value"
            cx="50%"
            cy="50%"
            innerRadius="55%"
            outerRadius="100%"
            isAnimationActive={false}
            startAngle={sortedClockwise ? 90 : 0}
            endAngle={sortedClockwise ? -270 : 360}
          >
            {data.map((item, index) => (
              <Cell key={`cell-${index}`} fill={item.color || colors[index % colors.length]} stroke="none" />
            ))}
          </Pie>
        </RePieChart>
      </ResponsiveContainer>
    </div>
  );
}
